/*
 * @description: 字典
 * @Author: wxy
 * @Date: 2019-03-27 10:08:00
 */

const communityType = {
  home: '0',
  question: '1',
  share: '2',
  discuss: '3',
  suggest: '4',
  notice: '5',
  dynamic: '6'
}

const communityTypeD = {
  [communityType.question]: '提问',
  [communityType.share]: '分享',
  [communityType.discuss]: '讨论',
  [communityType.suggest]: '建议',
  [communityType.notice]: '公告'
}

const publishType = {
  publish: '0', // 我的发布
  store: '1' // 我的收藏
}

const listTypeD = {
  all: '0',
  open: '1',
  close: '2',
  excellent: '3'
}

const rangeTypeD = {
  time: 'publishTime',
  hot: 'commentCount'
}
export { communityType, communityTypeD, publishType, listTypeD, rangeTypeD }



// WEBPACK FOOTER //
// ./src/views/community/utils/dictionary.js